import { kea } from 'kea'
import { put } from 'redux-saga/effects'
import { Validations } from 'validations'

import PropTypes from 'prop-types'
import DataLogic from 'containers/App/logic'
import moment from 'moment'

/* eslint-disable camelcase */
const defaultValues = {
  consumptionDisaggregation: 's',
  electricityConsumptionsRegistration: [
    { startDate: moment().date(1).month(0).format('YYYY-MM-DD'), endDate: moment().date(31).month(0).format('YYYY-MM-DD'), simples: '', svazio: '', cheias: '', ponta: '' }
  ],
  gasConsumptionsRegistration: [
    {startDate: moment().date(1).month(0).format('YYYY-MM-DD'), endDate: moment().date(31).month(0).format('YYYY-MM-DD'), consumption: ''}
  ]
}

const fields = {
  'electricityConsumptionsRegistration': [
    Validations.ignoreIf.isGas,
    Validations.noDuplicateDates,
    Validations.valuesGreaterThanZero
  ],

  'gasConsumptionsRegistration': [
    Validations.ignoreIf.isElectricity,
    Validations.noDuplicateDates,
    Validations.valuesGreaterThanZero
  ]
}

const consumptionDisaggregations = [
  {
    id: 's',
    name: 'Simples',
    text: 'Simples',
    value: 's'
  },
  {
    id: 'vf',
    name: 'Vazio / Fora de vazio',
    text: 'Vazio / Fora de vazio',
    value: 'vf'
  },
  {
    id: 'vcp',
    name: 'Vazio /  Cheias / Ponta',
    text: 'Vazio /  Cheias / Ponta',
    value: 'vcp'
  },
  {
    id: 'vscp',
    name: 'Vazio / Super Vazio /  Cheias / Ponta',
    text: 'Vazio / Super Vazio /  Cheias / Ponta',
    value: 'vscp'
  }
]
export default kea({
  path: () => ['scenes', 'consume'],
  connect: {
    actions: [DataLogic, ['setValue', 'setValues', 'setFinished', 'iframed']],
    props: [DataLogic, ['values', 'offerType', 'finished', 'translations']]
  },

  actions: () => ({
    fetchFilters: () => ({ }),
    fetchError: (error) => ({ error }),
    setFilters: (filters) => ({ filters }),
    setInvalid: (invalid) => ({ invalid })
  }),

  start: function * () {
    const { setValues } = this.actions
    const { ciclo_horario, consumptionDisaggregation } = yield DataLogic.get('values')
    const { profileFinished } = yield DataLogic.get('finished')

    // https://sentry2.ubiwhere.com/ubiwhere/simulador-avancado/issues/3364/
    if (!profileFinished) {
      this.props.router.push('/')
    }

    // Ao escolher Bi-horário, por defeito a
    // DESAGREGAÇÃO DOS CONSUMOS DE ELETRICIDADE deve ser Vazio/Fora do Vazio
    // https://gitlab.ubiwhere.com/adene-poupa-energia/adene-simulador-avancado/issues/14
    if (ciclo_horario === 'b') {
      defaultValues.consumptionDisaggregation = 'vf'
    }

    if (!consumptionDisaggregation) {
      yield put(setValues(defaultValues))
    }
  },

  reducers: ({ actions }) => ({
    filters: [{ consumptionDisaggregations }, PropTypes.any, {
      [actions.setFilters]: (_, payload) => ({ ...payload.filters })
    }],

    invalid: [{}, PropTypes.object, {
      [actions.setInvalid]: (_, payload) => payload.invalid
    }],

    fields: [fields, PropTypes.object, {}],

    error: [false, PropTypes.array, {
      [actions.fetchFilters]: () => false,
      [actions.setFilters]: () => false,
      [actions.fetchError]: (_, payload) => payload.error
    }]
  })

})



// WEBPACK FOOTER //
// ./src/containers/Consume/logic.js